<template>
  <div style="height:100%;overflow-y:auto;">
    <el-card style="margin-bottom: 20px;">
      <div class="title">个人信息</div>
      <div class="infobox">
        <el-image class="ib_l" :src="userData.avatar" fit="cover"></el-image>
        <div class="ib_r">
          <div class="welcome">{{hoursTip}}</div>
          <div class="ib_once">
            <span>昵称：</span>
            <p>{{userData.account}}</p>
          </div>
          <div class="ib_once">
            <span>上次登录IP：</span>
            <p>{{userData.login_ip}}</p>
          </div>
          <div class="ib_once">
            <span>上次登录时间：</span>
            <p>{{userData.login_time}}</p>
          </div>
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
  import QRCode from 'qrcodejs2';
  export default {
    data() {
      return {
        loading: false, //是显示加载
        hoursTip: '',
        userData: '',
      }
    },
    created() {
      let date = new Date();
      if (date.getHours() >= 0 && date.getHours() < 12) {
        this.hoursTip = "上午好"
      } else if (date.getHours() >= 12 && date.getHours() < 18) {
        this.hoursTip = "下午好"
      } else {
        this.hoursTip = "晚上好"
      }
      this.userData = JSON.parse(localStorage.getItem('userdata_shop'))
    },
    methods: {}
  }
</script>

<style scoped>
  .title {
    font-size: 14px;
    color: #303133;
    font-weight: 600;
    padding-bottom: 20px;
    border-bottom: 1px solid #e4e7ed;
    margin-bottom: 20px;
  }

  .infobox {
    display: flex;
    align-items: center;
  }

  .ib_l {
    width: 130px;
    height: 130px;
    margin-right: 15px;
  }

  .ib_r {
    flex: 1;
  }

  .welcome {
    font-size: 18px;
    color: #303133;
  }

  .ib_once {
    display: flex;
    align-items: center;
    padding: 3px 0;
  }

  .ib_once span:first-child {
    font-size: 13px;
    color: #909399;
    width: 100px;
  }

  .ib_once p {
    margin: 0;
    font-size: 13px;
    color: #303133;
    margin-right: 10px;
  }

  .ib_once .btn {
    padding: 0;
  }

  .levelbox {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    margin-bottom: 20px;
  }

  .ll_once {
    width: 150px;
    height: 170px;
    border: 2px solid #dcdcdc;
    border-radius: 8px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    margin-right: 24px;
    margin-bottom: 10px;
  }

  .ll_once:nth-child(3n) {
    margin-right: 0;
  }

  .ll_once_o {
    border-color: #ff9d00;
    background: #fcf7e6;
  }

  .ll_once_name {
    text-align: center;
    font-size: 18px;
    color: #424242;
    padding: 20px 0 16px;
  }

  .ll_once_price {
    text-align: center;
    font-size: 14px;
    color: #ff9d00;
  }

  .ll_once_price span {
    font-style: italic;
    font-size: 26px;
    font-weight: bold;
  }

  .ll_once_desc {
    text-align: center;
    font-size: 12px;
    color: #808080;
    padding-top: 10px;
  }

  .ll_once_fixed {
    position: absolute;
    bottom: 0;
    right: 0;
    width: 0;
    height: 0;
    border-top: 22px solid transparent;
    border-left: 22px solid transparent;
    border-bottom: 22px solid #ff9d00;
    border-right: 22px solid #ff9d00;
  }

  .ll_once_fixed i {
    font-size: 20px;
    color: white;
  }

  .ll_info {
    display: flex;
    padding: 10px 0;
  }

  .ll_info span {
    flex-shrink: 0;
    font-size: 15px;
    color: #808080;
    width: 80px;
    line-height: 26px;
  }

  .ll_info p {
    font-size: 16px;
    color: #606266;
    line-height: 26px;
    font-style: italic;
    margin: 0;
  }

  .ll_info div {
    font-size: 20px;
    color: #ff9d00;
    line-height: 26px;
  }

  .codebox {
    display: flex;
    align-items: center;
    justify-content: space-around;
    margin-top: 20px;
  }

  .cb_once_t {
    width: 160px;
    height: 160px;
    border-radius: 6px;
    margin-bottom: 10px;
  }

  .cb_once_b {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    color: #303133;
    margin-top: 20px;
  }

  .cb_once_b img {
    width: 30px;
    height: 30px;
    margin-right: 10px;
  }

  .btnbox {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/views/userCenter/index.vue